import { Card, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useCallback } from "react";
import { useInView } from "react-intersection-observer";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { PLACEMENT_PATHS } from "../paths";

export function InstantPayHiringBanner() {
  const history = useHistory();
  const { userId: workerId } = useDefinedWorker();

  const { ref } = useInView({
    triggerOnce: true,
    threshold: 0,
    onChange: (inView) => {
      if (!inView) {
        return;
      }

      logEvent(APP_V2_APP_EVENTS.PLACEMENT_INSTANT_PAY_BANNER_VIEWED, {
        workerId,
      });
    },
  });

  const handleGetPaidNowClick = useCallback(() => {
    logEvent(APP_V2_APP_EVENTS.HIRING_INSTANT_PAY_BANNER_GET_PAID_NOW_CLICKED, { workerId });
    history.push(PLACEMENT_PATHS.HIRING_INSTANT_PAY_TRIAL);
  }, [history, workerId]);

  return (
    <Card
      ref={ref}
      sx={{
        paddingY: 5,
        paddingX: 5,
        background: "linear-gradient(180deg, #D4F5DD 0%, #C2F0CF 100%)",
        border: "1px solid #3D634D",
        borderRadius: 5,
      }}
    >
      <Stack spacing={4}>
        <Text
          variant="h6"
          sx={{
            letterSpacing: "0.002em",
            lineHeight: "1.3rem",
          }}
        >
          Get Paid the minute you clock out.
        </Text>
        <Stack direction="row" alignItems="center" flexWrap="wrap">
          <Text
            variant="body1"
            sx={{
              letterSpacing: "0.002em",
              lineHeight: "1.3rem",
              width: "fit-content",
            }}
          >
            We are trialling{" "}
            <Text variant="body1" sx={{ display: "inline", fontWeight: 700 }}>
              Instant Pay
            </Text>{" "}
            for select permanent jobs. Click below to learn more.
          </Text>
        </Stack>
        <Box sx={{ pt: 2 }}>
          <Button size="small" onClick={handleGetPaidNowClick}>
            Get Paid Now
          </Button>
        </Box>
      </Stack>
    </Card>
  );
}
